/* Modern theme runtime — slideshow, FAQ, scroll reveals
   Customizer-aware: re-initializes on shopify:section:load/select. */
(function(){
  var inEditor = (typeof Shopify !== 'undefined' && Shopify.designMode);
  if(inEditor){ try{ document.documentElement.classList.add('shopify-design-mode'); }catch(e){} }

  function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn);}

  function initSlideshow(root){
    if(root.__mInit) return;
    root.__mInit = true;

    /* Hero V2 — crossfade */
    if(root.classList.contains('m-hero-v2')){
      var slides = root.querySelectorAll('.m-hero-v2__slide');
      var dots = root.querySelectorAll('.m-hero-v2__dot');
      if(!slides.length) return;

      var i = 0, total = slides.length, timer = null;
      var auto = parseInt(root.getAttribute('data-autoplay') || '6000', 10);

      function splitWords(el, baseIndex){
        if(el.__splitDone) return baseIndex;
        var text = (el.getAttribute('data-original') || el.textContent).trim();
        el.setAttribute('data-original', text);
        el.setAttribute('aria-label', text);
        var words = text.split(/\s+/).filter(Boolean);
        el.innerHTML = words.map(function(word, idx){
          var wi = baseIndex + idx;
          return '<span class="m-hero-v2__word" style="--wi:' + wi + '">' + word + '</span>';
        }).join(' ');
        el.__splitDone = true;
        return baseIndex + words.length;
      }

      function prepareHeroText(slide){
        if(slide.__textReady) return;
        var idx = 0;
        slide.querySelectorAll('[data-split-words]').forEach(function(el){
          idx = splitWords(el, idx);
        });
        var btn = slide.querySelector('[data-hero-btn]');
        if(btn){
          var fx = slide.getAttribute('data-text-fx') || 'rise';
          var stagger = fx === 'rise' ? 0.11 : 0.075;
          btn.style.setProperty('--btn-delay', (0.35 + idx * stagger + 0.35) + 's');
        }
        slide.__textReady = true;
      }

      function playHeroText(slide){
        if(!slide) return;
        prepareHeroText(slide);
        slide.classList.remove('is-text-in');
        slide.querySelectorAll('.m-hero-v2__word').forEach(function(word){
          word.style.animation = 'none';
        });
        var btn = slide.querySelector('[data-hero-btn]');
        if(btn) btn.style.animation = 'none';
        void slide.offsetWidth;
        slide.querySelectorAll('.m-hero-v2__word').forEach(function(word){
          word.style.animation = '';
        });
        if(btn) btn.style.animation = '';
        slide.classList.add('is-text-in');
      }

      slides.forEach(prepareHeroText);

      function syncVideos(){
        slides.forEach(function(s,k){
          var active = k === i;
          s.querySelectorAll('video').forEach(function(video){
            if(active){
              video.play && video.play().catch(function(){});
            } else {
              video.pause && video.pause();
            }
          });
          s.querySelectorAll('iframe.m-hero-v2__embed').forEach(function(frame){
            var src = frame.getAttribute('src') || '';
            try {
              if(src.indexOf('youtube.com') !== -1 && frame.contentWindow){
                frame.contentWindow.postMessage(JSON.stringify({
                  event: 'command',
                  func: active ? 'playVideo' : 'pauseVideo',
                  args: []
                }), '*');
              } else if(src.indexOf('vimeo.com') !== -1 && frame.contentWindow){
                frame.contentWindow.postMessage(JSON.stringify({
                  method: active ? 'play' : 'pause'
                }), '*');
              }
            } catch (err) {}
          });
        });
      }

      function go(n){
        i = (n + total) % total;
        slides.forEach(function(s,k){
          var active = k === i;
          s.classList.toggle('is-active', active);
          s.setAttribute('aria-hidden', active ? 'false' : 'true');
          if(!active) s.classList.remove('is-text-in');
        });
        dots.forEach(function(d,k){
          d.classList.toggle('is-active', k === i);
          d.setAttribute('aria-selected', k === i ? 'true' : 'false');
          d.setAttribute('tabindex', k === i ? '0' : '-1');
        });
        syncVideos();
        playHeroText(slides[i]);
      }

      function play(){
        if(auto > 0 && total > 1){
          stop();
          timer = setInterval(function(){ go(i + 1); }, auto);
        }
      }

      function stop(){
        if(timer){ clearInterval(timer); timer = null; }
      }

      dots.forEach(function(d,k){
        d.addEventListener('click', function(){ go(k); play(); });
        d.addEventListener('keydown', function(e){
          if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
          e.preventDefault();
          var next = k;
          if(e.key === 'ArrowRight') next = (k + 1) % dots.length;
          if(e.key === 'ArrowLeft') next = (k - 1 + dots.length) % dots.length;
          if(e.key === 'Home') next = 0;
          if(e.key === 'End') next = dots.length - 1;
          go(next);
          dots[next].focus();
          play();
        });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', play);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', function(e){ if(!root.contains(e.relatedTarget)) play(); });

      root.addEventListener('shopify:block:select', function(e){
        var idx = Array.prototype.indexOf.call(slides, e.target);
        if(idx >= 0){ stop(); go(idx); }
      });
      root.addEventListener('shopify:block:deselect', play);

      go(0);
      play();
      return;
    }

    /* Legacy hero fallback */
    var slides=root.querySelectorAll('.m-hero-slide');
    var dots=root.querySelectorAll('.m-hero-dot');
    var track=root.querySelector('.m-hero-track');
    var prev=root.querySelector('.m-hero-arrow--prev');
    var next=root.querySelector('.m-hero-arrow--next');
    if(!slides.length||!track) return;
    var i=0, total=slides.length, timer=null;
    var auto=parseInt(root.getAttribute('data-autoplay')||'6000',10);
    function go(n){
      i=(n+total)%total;
      track.style.transform='translateX(-'+(i*100)+'%)';
      slides.forEach(function(s,k){s.classList.toggle('is-active',k===i);});
      dots.forEach(function(d,k){d.classList.toggle('is-active',k===i);});
    }
    function play(){if(auto>0 && total>1){stop();timer=setInterval(function(){go(i+1);},auto);}}
    function stop(){if(timer){clearInterval(timer);timer=null;}}
    dots.forEach(function(d,k){d.addEventListener('click',function(){go(k);play();});});
    if(prev)prev.addEventListener('click',function(){go(i-1);play();});
    if(next)next.addEventListener('click',function(){go(i+1);play();});
    root.addEventListener('mouseenter',stop);
    root.addEventListener('mouseleave',play);
    go(0);play();
  }

  function initFaq(root){
    if(root.__mInit) return; root.__mInit = true;
    root.querySelectorAll('.m-faq-item').forEach(function(item){
      var btn=item.querySelector('.m-faq-q');
      if(!btn) return;
      var panelId = btn.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : item.querySelector('.m-faq-a');
      function sync(open){
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if(panel){
          panel.setAttribute('aria-hidden', open ? 'false' : 'true');
          panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
        }
      }
      sync(item.classList.contains('is-open'));
      btn.addEventListener('click',function(){ sync(!item.classList.contains('is-open')); });
      window.addEventListener('resize', function(){ if(item.classList.contains('is-open') && panel) panel.style.maxHeight = panel.scrollHeight + 'px'; });
    });
  }

  function revealAll(scope){
    (scope||document).querySelectorAll('.m-reveal').forEach(function(el){el.classList.add('is-in');});
  }

  function initReveal(scope){
    if(inEditor || !('IntersectionObserver' in window)){ revealAll(scope); return; }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}
      });
    },{threshold:.08,rootMargin:'0px 0px -10% 0px'});
    (scope||document).querySelectorAll('.m-reveal:not(.is-in)').forEach(function(el){io.observe(el);});
    setTimeout(function(){ revealAll(scope); }, 2500);
  }

  function initStats(root){
    if(root.__mStatsInit) return; root.__mStatsInit = true;
    var nums = root.querySelectorAll('[data-count-to]');
    if(!nums.length) return;
    function animate(el){
      var target = parseInt(el.getAttribute('data-count-to'), 10) || 0;
      var start = 0; var dur = 1400; var t0 = null;
      function step(ts){
        if(!t0) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(start + (target - start) * eased).toLocaleString();
        if(p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if(inEditor || !('IntersectionObserver' in window)){
      nums.forEach(animate); return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ animate(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.3 });
    nums.forEach(function(el){ io.observe(el); });
  }

  function initMarquee(root){
    if(root.__mMarqueeInit) return; root.__mMarqueeInit = true;
    var track = root.querySelector('.m-marquee__track');
    if(!track) return;
    var speed = parseInt(track.getAttribute('data-marquee-speed') || '28', 10);
    track.style.setProperty('--m-marquee-duration', speed + 's');
  }

  function initAnnounceRotator(root){
    if(root.__mAnnounceInit) return; root.__mAnnounceInit = true;
    if(root.getAttribute('data-announce-display') !== 'rotate' && !root.hasAttribute('data-announce-rotate')) return;

    var msgs = root.querySelectorAll('.announce-rotator__msg');
    if(!msgs.length) return;

    var dots = root.querySelectorAll('.announce-rotator__dot');
    var progress = root.querySelector('.announce-rotator__progress span');
    var viewport = root.querySelector('.announce-rotator__viewport');
    var interval = (parseInt(root.getAttribute('data-rotate-interval') || '5', 10) || 5) * 1000;
    var i = 0, timer = null, exiting = false;

    function syncViewportWidth(idx){
      if(!viewport || !msgs.length) return;
      var msg = msgs[idx != null ? idx : i];
      if(!msg) return;
      viewport.style.width = Math.ceil(msg.scrollWidth) + 'px';
    }

    function resetProgress(){
      if(!progress) return;
      progress.style.animation = 'none';
      void progress.offsetWidth;
      progress.style.animation = '';
    }

    function setDots(idx){
      dots.forEach(function(d,k){ d.classList.toggle('is-active', k === idx); });
    }

    function go(n){
      var next = (n + msgs.length) % msgs.length;
      if(next === i) return;
      msgs[i].classList.remove('is-active');
      msgs[i].classList.add('is-exiting');
      exiting = true;

      setTimeout(function(){
        msgs[i].classList.remove('is-exiting');
        i = next;
        msgs[i].classList.add('is-active');
        setDots(i);
        syncViewportWidth(i);
        resetProgress();

        if(root.classList.contains('announcement-bar--anim-stagger')){
          msgs[i].querySelectorAll('.announce-char').forEach(function(ch){
            ch.style.animation = 'none';
            void ch.offsetWidth;
            ch.style.animation = '';
          });
        }
        exiting = false;
      }, 420);
    }

    function play(){
      stop();
      if(msgs.length > 1){
        timer = setInterval(function(){ if(!exiting) go(i + 1); }, interval);
      }
      resetProgress();
    }

    function stop(){
      if(timer){ clearInterval(timer); timer = null; }
    }

    msgs.forEach(function(m,k){ m.classList.toggle('is-active', k === 0); });
    setDots(0);
    syncViewportWidth(0);
    window.addEventListener('resize', function(){ syncViewportWidth(); });
    play();

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
  }

  function initAnnounceMarquee(root){
    var track = root.querySelector('.marquee-track');
    if(!track) return;
    var speed = parseInt(track.getAttribute('data-marquee-speed') || '12', 10);
    root.style.setProperty('--announce-marquee', speed + 's');
  }

  function initDragScroll(root){
    if(root.__mDragInit) return; root.__mDragInit = true;
    var down = false, startX = 0, scrollLeft = 0;
    root.addEventListener('mousedown', function(e){
      down = true; root.classList.add('is-dragging');
      startX = e.pageX - root.offsetLeft; scrollLeft = root.scrollLeft;
    });
    root.addEventListener('mouseleave', function(){ down = false; root.classList.remove('is-dragging'); });
    root.addEventListener('mouseup', function(){ down = false; root.classList.remove('is-dragging'); });
    root.addEventListener('mousemove', function(e){
      if(!down) return; e.preventDefault();
      var x = e.pageX - root.offsetLeft;
      root.scrollLeft = scrollLeft - (x - startX) * 1.2;
    });
  }

  function initTabProducts(root){
    if(root.__mTabInit) return;
    root.__mTabInit = true;
    var tabs = Array.from(root.querySelectorAll('.m-tab-products__tab'));
    var panels = Array.from(root.querySelectorAll('.m-tab-products__panel'));
    if(!tabs.length || !panels.length) return;

    function activate(tab, focus){
      var idx = tab.getAttribute('data-tab-index');
      tabs.forEach(function(t){
        var active = t === tab;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.setAttribute('tabindex', active ? '0' : '-1');
      });
      panels.forEach(function(panel){
        var active = panel.getAttribute('data-tab-panel') === idx;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
      if(focus) tab.focus();
    }

    tabs.forEach(function(tab, index){
      tab.addEventListener('click', function(){ activate(tab, false); });
      tab.addEventListener('keydown', function(e){
        if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
        e.preventDefault();
        var next = index;
        if(e.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if(e.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if(e.key === 'Home') next = 0;
        if(e.key === 'End') next = tabs.length - 1;
        activate(tabs[next], true);
      });
    });
  }

  function initCollectionDrawer(root){
    if(root.__mCollectionInit) return;
    root.__mCollectionInit = true;

    var openBtn = root.querySelector('[data-m-filter-open]');
    var drawer = root.querySelector('[data-m-filter-drawer]');
    var overlay = root.querySelector('[data-m-filter-overlay]');
    var closeBtn = root.querySelector('[data-m-filter-close]');
    if(!openBtn || !drawer) return;

    var lastFocus = null;
    var releaseTrap = null;
    var mobile = window.matchMedia('(max-width: 880px)');

    function syncMode(){
      if(mobile.matches){
        if(!drawer.classList.contains('is-open')){
          drawer.setAttribute('aria-hidden','true');
          drawer.inert = true;
        }
      } else {
        drawer.classList.remove('is-open');
        if(overlay) overlay.classList.remove('is-open');
        drawer.removeAttribute('aria-hidden');
        drawer.inert = false;
        document.body.classList.remove('m-coll-filter-open');
        openBtn.setAttribute('aria-expanded','false');
        if(releaseTrap){ releaseTrap(); releaseTrap = null; }
      }
    }

    function setOpen(open){
      if(!mobile.matches && open) return;
      drawer.classList.toggle('is-open', open);
      if(overlay) overlay.classList.toggle('is-open', open);
      openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if(overlay) overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.classList.toggle('m-coll-filter-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      drawer.inert = !open;

      if(open){
        lastFocus = document.activeElement;
        releaseTrap = trap(drawer);
        window.requestAnimationFrame(function(){
          if(closeBtn) closeBtn.focus();
        });
      } else {
        if(releaseTrap){ releaseTrap(); releaseTrap = null; }
        if(lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus();
      }
    }

    openBtn.addEventListener('click', function(){ setOpen(true); });
    if(closeBtn) closeBtn.addEventListener('click', function(){ setOpen(false); });
    if(overlay) overlay.addEventListener('click', function(){ setOpen(false); });

    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false);
    });

    drawer.querySelectorAll('a[href]').forEach(function(link){
      link.addEventListener('click', function(){ if(mobile.matches) setOpen(false); });
    });

    var onModeChange = function(){
      if(drawer.classList.contains('is-open')) setOpen(false);
      syncMode();
    };
    if(mobile.addEventListener) mobile.addEventListener('change', onModeChange);
    else if(mobile.addListener) mobile.addListener(onModeChange);
    syncMode();
  }

  function initAll(scope){
    (scope||document).querySelectorAll('[data-m-hero]').forEach(initSlideshow);
    (scope||document).querySelectorAll('[data-m-faq]').forEach(initFaq);
    (scope||document).querySelectorAll('[data-m-stats]').forEach(initStats);
    (scope||document).querySelectorAll('[data-m-marquee]').forEach(initMarquee);
    (scope||document).querySelectorAll('[data-m-tab-products]').forEach(initTabProducts);
    (scope||document).querySelectorAll('[data-announce-bar]').forEach(function(bar){
      initAnnounceRotator(bar);
      initAnnounceMarquee(bar);
    });
    (scope||document).querySelectorAll('[data-m-drag-scroll]').forEach(initDragScroll);
    (scope||document).querySelectorAll('[data-m-collection]').forEach(initCollectionDrawer);
    initReveal(scope);
  }

  function initHeaderScroll(){
    var threshold = 40;
    function onScroll(){
      document.body.classList.toggle('m-header-scrolled', window.scrollY > threshold);
    }
    window.addEventListener('scroll', onScroll, {passive:true});
    onScroll();
  }

  function initMegaMenu(){
    var parents = document.querySelectorAll('[data-nav-parent]');
    if(!parents.length) return;
    var closeTimer = null;

    function syncBackdrop(){
      var open = document.querySelector('[data-nav-parent].is-open');
      document.body.classList.toggle('m-mega-open', !!open);
    }

    function closeAll(except){
      parents.forEach(function(item){
        if(except && item === except) return;
        item.classList.remove('is-open');
        var link = item.querySelector('.header__inline-nav-link--parent');
        var mega = item.querySelector('.header__mega');
        if(link) link.setAttribute('aria-expanded', 'false');
        if(mega){ mega.classList.remove('is-open'); mega.setAttribute('aria-hidden', 'true'); }
      });
      syncBackdrop();
    }

    function openItem(item, link, mega){
      clearTimeout(closeTimer);
      closeAll(item);
      item.classList.add('is-open');
      mega.classList.add('is-open');
      link.setAttribute('aria-expanded', 'true');
      mega.setAttribute('aria-hidden', 'false');
      syncBackdrop();
    }

    parents.forEach(function(item){
      var link = item.querySelector('.header__inline-nav-link--parent');
      var mega = item.querySelector('.header__mega');
      if(!link || !mega) return;

      var clickMode = item.getAttribute('data-nav-trigger') === 'click';

      if(clickMode){
        link.addEventListener('click', function(e){
          e.preventDefault();
          var open = item.classList.contains('is-open');
          closeAll();
          if(!open) openItem(item, link, mega);
        });
      } else {
        item.addEventListener('mouseenter', function(){
          openItem(item, link, mega);
        });
        item.addEventListener('mouseleave', function(){
          closeTimer = setTimeout(function(){ closeAll(); }, 80);
        });
      }
    });

    document.addEventListener('click', function(e){
      if(!e.target.closest('[data-nav-parent]')) closeAll();
    });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape') closeAll();
    });

    document.querySelectorAll('[data-mega-close]').forEach(function(el){
      el.addEventListener('click', function(){ closeAll(); });
    });
  }

  ready(function(){ initAll(document); initHeaderScroll(); initMegaMenu(); window.initModernReveal = initReveal; });

  document.addEventListener('shopify:section:load', function(e){
    initAll(e.target);
    revealAll(e.target);
    initMegaMenu();
  });
  document.addEventListener('shopify:section:select', function(e){ revealAll(e.target); });
  document.addEventListener('shopify:section:reorder', function(e){ revealAll(e.target); });
})();
